'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const React = require('react');
const React__default = _interopDefault(React);
const SharedLayoutContext = require('../../../context/SharedLayoutContext.js');
const useIsomorphicEffect = require('../../../utils/use-isomorphic-effect.js');

function useSnapshotOnUnmount(visualElement) {
  var syncLayout = React.useContext(SharedLayoutContext.SharedLayoutContext);
  var framerSyncLayout = React.useContext(SharedLayoutContext.FramerTreeLayoutContext);
  useIsomorphicEffect.useIsomorphicLayoutEffect(function () {
    return function () {
      if (SharedLayoutContext.isSharedLayout(syncLayout)) {
        syncLayout.remove(visualElement);
      }
      if (SharedLayoutContext.isSharedLayout(framerSyncLayout)) {
        framerSyncLayout.remove(visualElement);
      }
    };
  }, []);
}

exports.useSnapshotOnUnmount = useSnapshotOnUnmount;
